import React from 'react';
import cx from 'classnames';
import { IActiveCountry } from 'interfaces';

export interface IGQFlagProps {
    countryId: number;
    style?: React.CSSProperties;
    options?: {
        round?: boolean;
    };
    className?: string;
    id?: string;
    country: IActiveCountry;
}

type IProps = IGQFlagProps;

interface IGQFlagState {
    isHovering: boolean;
}
class ExportChartFlag extends React.PureComponent<IProps, IGQFlagState> {
    constructor(props: IProps) {
        super(props);
    }

    public render(): JSX.Element | false | null {
        const country = this.props.country;
        if (!country) {
            return null;
        }
        return (
            <span
                id={this.props.id}
                style={{ ...this.props.style }}
                className={cx([
                    `gq-flag flag-icon flag-icon-${country.abbreviation_short.toLowerCase()} ${
                        this.props.className ? this.props.className : ''
                    }`,
                    { round: this.props.options && this.props.options.round}
                ])}
            />
        );
    }
}

export default ExportChartFlag as React.ComponentClass<IGQFlagProps>;
